module.exports = __webpack_public_path__ + "static/process-detail-4b.6fdf8d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-4b.png
// module id = 1494
// module chunks = 214286880276331